import classNames from 'classnames'
import React, { useState } from 'react'
import Icon from '../icon'
import { IconType } from '../../../types/icon-name-types'

export interface InlineNotificationProps {
  messageType?: 'info' | 'success' | 'warning' | 'error'
  isDismissable?: boolean
}

export default function InlineNotification({
  messageType = 'info',
  isDismissable = false,
  children,
}: React.PropsWithChildren<InlineNotificationProps>) {
  const [isDismissed, setIsDismissed] = useState(false)
  const messageClasses = classNames('c-inline-notification', {
    [`c-inline-notification--${messageType}`]: !!messageType,
  })

  const iconOptions: { [key: string]: IconType } = {
    info: 'info',
    success: 'check-circle',
    warning: 'warning',
    error: 'warning',
  }

  return isDismissed ? null : (
    <div className={messageClasses} role='alert' aria-label={`${messageType} notification message`}>
      <Icon icon={iconOptions[messageType]} className='c-inline-notification__icon' ariaHidden={true} />
      <div className='c-inline-notification__message'>{children}</div>
      {isDismissable && (
        <button className='c-inline-notification__dismiss-btn' onClick={() => setIsDismissed(true)}>
          <Icon icon='cross-circle' ariaLabel='Dismiss notification' />
        </button>
      )}
    </div>
  )
}
